import { toast } from "react-toastify";
import t from "components/I18N/TranslateHelpers";

export type ValidationContext = {
  hasInvalidField: boolean;
  firstElement: number;
};

export const getEmptyRequiredFieldsSubmit = () => {
  const ctx: ValidationContext = { hasInvalidField: false, firstElement: 0 };

  const elements = document.querySelectorAll('label.required');
  const elementsRequiredSurvey = document.querySelectorAll('label.label-required-survey');
  const uploadPdfSection = document.getElementById('uploadPDFSection');

  elements.forEach((element) => {
    let nextElementOfLabel: any = element.nextElementSibling;
    if (!nextElementOfLabel) return;

    if (nextElementOfLabel.nodeName === "LABEL") {
      nextElementOfLabel = nextElementOfLabel.nextElementSibling;
      if (ctx.firstElement === 0) ctx.firstElement = nextElementOfLabel.getBoundingClientRect().y;
    }

    if (nextElementOfLabel.nodeName === "INPUT" && nextElementOfLabel.value === '') {
      if (!nextElementOfLabel.nextElementSibling || nextElementOfLabel.nextElementSibling.nodeName !== "BUTTON") {
        element.classList.add('error-empty-fields');
        nextElementOfLabel.classList.add('error-empty-fields');
        ctx.hasInvalidField = true;
        if (ctx.firstElement === 0) ctx.firstElement = nextElementOfLabel.getBoundingClientRect().y;
      }
    }

    if (nextElementOfLabel.classList.contains("css-b62m3t-container")) {
      const selectChilds = nextElementOfLabel.getElementsByClassName('css-1s2u09g-control');
      const valueSelected = nextElementOfLabel.getElementsByClassName('css-qc6sy-singleValue');
      if (valueSelected.length === 0) {
        ctx.hasInvalidField = true;
        for (let selectChild of selectChilds) {
          element.classList.add('error-empty-fields');
          selectChild.classList.add('error-empty-fields');
          if (ctx.firstElement === 0) ctx.firstElement = nextElementOfLabel.getBoundingClientRect().y;
        }
      }
    }

    if (nextElementOfLabel.nodeName === "SELECT" && (nextElementOfLabel.value === '' || nextElementOfLabel.selectedIndex === 0)) {
      element.classList.add('error-empty-fields');
      nextElementOfLabel.classList.add('error-empty-fields');
      ctx.hasInvalidField = true;
      if (ctx.firstElement === 0) ctx.firstElement = nextElementOfLabel.getBoundingClientRect().y;
    }

    if (nextElementOfLabel.nodeName === "DIV" && nextElementOfLabel.classList.contains('input-group')) {
      const inputChild = nextElementOfLabel.querySelectorAll('input[type=email]');
      validationForInput(inputChild, element, ctx, nextElementOfLabel);
    }

    if (nextElementOfLabel.nodeName === "TEXTAREA" && nextElementOfLabel.value === '') {
      validationForTextarea(element, nextElementOfLabel);
      ctx.hasInvalidField = true;
      if (ctx.firstElement === 0) ctx.firstElement = nextElementOfLabel.getBoundingClientRect().y;
    }

    const parentDateLabelDatePicker: any = element.parentNode;
    if (parentDateLabelDatePicker?.classList.contains('form-datepicker')) {
      const inputdatepicker = nextElementOfLabel.querySelectorAll('input');
      inputdatepicker.forEach((input: HTMLInputElement) => {
        if (input.value === '') {
          input.closest('.form-datepicker')?.classList.add('error-empty-fields');
          ctx.hasInvalidField = true;
          if (ctx.firstElement === 0) ctx.firstElement = nextElementOfLabel.getBoundingClientRect().y;
        }
      });
    }

    const inputWrapperSchools = document.getElementsByClassName('input-schools-print');
    Array.from(inputWrapperSchools).forEach((item) => {
      const inputs = item.getElementsByTagName('input');
      Array.from(inputs).forEach((input) => {
        if (input.value === '' || input.value === '0') {
          input.classList.add('error-empty-fields');
          ctx.hasInvalidField = true;
        }
      });
    });
  });

  if (uploadPdfSection) {
    const label = uploadPdfSection.querySelector('label.required');
    const input = uploadPdfSection.querySelector('#section-pdf-upload');
    if (label && input) validationForInputFile(input, label, ctx);
  }

  elementsRequiredSurvey.forEach((label) => {
    const parent = label.closest('li');
    const firstParent = label.parentNode;

    if (label.classList.contains('field-required-first-parent') && firstParent) {
      const inputs = firstParent.querySelectorAll('input');
      validationForInput(inputs, label, ctx, firstParent);
    }

    const textarea = parent?.querySelector('textarea');
const group = parent?.querySelector('.custom-radio-ml') 
  || label.closest('li')?.querySelector('.custom-radio-ml');


    if (textarea && textarea.value === '') {
      validationForTextarea(label, textarea);
      ctx.hasInvalidField = true;
      if (ctx.firstElement === 0) ctx.firstElement = textarea.getBoundingClientRect().y;
    }

    if (group && (label.classList.contains('required') || label.classList.contains('label-required-survey'))) {
      const radios = group.querySelectorAll('input[type="radio"]');
      const checkboxes = group.querySelectorAll('input[type="checkbox"]');

      let isValid = true;
      if (radios.length > 0) isValid = Array.from(radios).some(r => (r as HTMLInputElement).checked);
      else if (checkboxes.length > 0) isValid = Array.from(checkboxes).some(c => (c as HTMLInputElement).checked);

if (!isValid) {
  group.classList.add('error-empty-fields');
  label.classList.add('error-empty-fields');
  ctx.hasInvalidField = true;
  if (ctx.firstElement === 0) ctx.firstElement = group.getBoundingClientRect().y;
} else {
  group.classList.remove('error-empty-fields');
  label.classList.remove('error-empty-fields');
}

    }
  });


  const fileUploads = document.querySelectorAll('.section-photo-album input[type="file"].file-upload-avatar');
  fileUploads.forEach((input) => {
    const wrapper = input.closest('.avatar');
    const img = wrapper?.querySelector('img');
    const empty = !img || img.getAttribute('src') === "../assets/images/mywep-upload-image.png";
    const label = document.querySelector(`label[for="${input.id}"]`);

    if (empty) {
      input.classList.add('error-empty-fields');
      label?.classList.add('error-empty-fields');
      img?.classList.add('error-empty-fields');
      if (ctx.firstElement === 0) ctx.firstElement = input.getBoundingClientRect().y;
    } else {
      input.classList.remove('error-empty-fields');
      label?.classList.remove('error-empty-fields');
      img?.classList.remove('error-empty-fields');
    }
  });

  const letterSections = document.querySelectorAll('textarea[id^="letters["]');
  letterSections.forEach((el) => {
    const textarea = el as HTMLTextAreaElement;
    const wrapper = textarea.closest('.col-md-12');
    const instruction = wrapper?.querySelector('p');
    const label = wrapper?.querySelector('label');
    const match = instruction?.textContent?.match(/between\s+(\d+)\s+and\s+(\d+)/i);

    if (match) {
      const min = parseInt(match[1]);
      const max = parseInt(match[2]);
      const len = textarea.value.trim().length;

      if (len < min || len > max) {
        textarea.classList.add('error-empty-fields');
        label?.classList.add('error-empty-fields');
        instruction?.classList.add('error-empty-fields');
        if (ctx.firstElement === 0) ctx.firstElement = textarea.getBoundingClientRect().y;
      }
    }
  });

  const tableRows = document.querySelectorAll('#collapseapplicantTeacher table tr, #collapseapplicantLanguageTeacherRecommendation table tr');
  tableRows.forEach((row) => {
    const inputs = row.querySelectorAll('input[type="radio"]');
    if (inputs.length > 0) {
      const isChecked = Array.from(inputs).some((input) => (input as HTMLInputElement).checked);

      if (!isChecked) {
        row.classList.add('error-empty-fields');
        inputs.forEach((input) => input.classList.add('error-empty-fields'));
        ctx.hasInvalidField = true;
        if (ctx.firstElement === 0) ctx.firstElement = row.getBoundingClientRect().y;
      } else {
        row.classList.remove('error-empty-fields');
        inputs.forEach((input) => input.classList.remove('error-empty-fields'));
      }
    }
  });

  const agreementContainers = document.querySelectorAll('.container-agreement');
  agreementContainers.forEach((container) => {
    const dropzone = container.querySelector('.card-agreement-dropzone');
    const fileInputs = container.querySelectorAll('input[type="file"]');
    const displayedFiles = container.querySelectorAll('.pull-left button');

  const hasFile =
    Array.from(fileInputs).some((input) =>
      (input as HTMLInputElement).files?.length && (input as HTMLInputElement).files!.length > 0
    ) ||
    displayedFiles.length > 0; 


    if (!hasFile) {
      dropzone?.classList.add('error-empty-fields');
      if (ctx.firstElement === 0 && dropzone) ctx.firstElement = dropzone.getBoundingClientRect().y;
    } else {
      dropzone?.classList.remove('error-empty-fields');
    }
  });

const conditionalTextareas = document.querySelectorAll('textarea[id^="SURVEY-"][id*="ANSWER-COMMENT"]') as NodeListOf<HTMLTextAreaElement>;

conditionalTextareas.forEach((textarea) => {
  const match = textarea.id.match(/ANSWER-COMMENT-(\d+)/);
  if (!match) return;

  const yesAnswerId = match[1];
  const yesRadio = document.querySelector(`input[type="radio"]#SURVEY-13266.QUESTION-118-SURVEY-13266.ANSWER-${yesAnswerId}`) as HTMLInputElement;

  const textareaLabel = textarea.closest('div')?.querySelector('label');

  if (yesRadio?.checked) {
    if (textarea.value.trim() === '') {
      textarea.classList.add('error-empty-fields');
      textareaLabel?.classList.add('error-empty-fields');
      ctx.hasInvalidField = true;
      if (ctx.firstElement === 0) ctx.firstElement = textarea.getBoundingClientRect().y;
    } else {
      textarea.classList.remove('error-empty-fields');
      textareaLabel?.classList.remove('error-empty-fields');
    }
  } else {
    textarea.classList.remove('error-empty-fields');
    textareaLabel?.classList.remove('error-empty-fields');
  }
});

validateEvaluationSystem(ctx);


  const allInvalidFields = Array.from(document.querySelectorAll('[class*="error-empty-field"]')) as HTMLElement[];
  if (allInvalidFields.length === 0) {
    ctx.hasInvalidField = false;
    toast.success(t('all_fields_are_completed'));
  } else {
    scrollToPosition(document.getElementById('mywepBody'), ctx.firstElement - 150, 500);
  }
};

export const validationForInput = (inputs: any, label: any, ctx: ValidationContext, container: any) => {
  Array.from(inputs).forEach((input: any) => {
    if (!input.readOnly && !input.disabled && input.value === '') {
      input.classList.add('error-empty-fields');
      label.classList.add('error-empty-fields');
      ctx.hasInvalidField = true;
      if (ctx.firstElement === 0) ctx.firstElement = container.getBoundingClientRect().y;
    }
  });
};

export const validationForTextarea = (label: any, textarea: any) => {
  label.classList.add('error-empty-fields');
  textarea.classList.add('error-empty-fields');
};

export const validationForInputFile = (input: any, label: any, ctx: ValidationContext) => {
  if (input.nodeName === 'INPUT' && input.value === '') {
    label.classList.add('error-empty-fields');
    input.classList.add('error-empty-fields');
    ctx.hasInvalidField = true;
    if (ctx.firstElement === 0) ctx.firstElement = input.getBoundingClientRect().y;
  }
};
export const validateEvaluationSystem = (ctx: ValidationContext) => {
  const container = document.querySelector('#collapseschoolstranscript');
  if (!container) return;

  const label = container.querySelector('label.required');
  const group = container.querySelector('.custom-radio-ml');

  if (!label || !group) return;

  const radios = group.querySelectorAll('input[type="radio"]');
  const isChecked = Array.from(radios).some((radio) => (radio as HTMLInputElement).checked);

  if (!isChecked) {
    label.classList.add('error-empty-fields');
    group.classList.add('error-empty-fields');
    ctx.hasInvalidField = true;
    if (ctx.firstElement === 0) ctx.firstElement = group.getBoundingClientRect().y;
  } else {
    label.classList.remove('error-empty-fields');
    group.classList.remove('error-empty-fields');
  }
};
export const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
  t /= d / 2;
  if (t < 1) return c / 2 * t * t + b;
  t--;
  return -c / 2 * (t * (t - 2) - 1) + b;
};

export const scrollToPosition = (element: any, to: number, duration: number) => {
  const start = element.scrollTop;
  const change = to - start;
  let currentTime = 0;
  const increment = 20;

  const animateScroll = function () {
    currentTime += increment;
    const val = easeInOutQuad(currentTime, start, change, duration);
    element.scrollTop = val;
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
};